import clsx from 'clsx'
import React from 'react'

import { Checkbox } from '../Checkbox'
import { StickyCellBorder } from './StickyCellBorder'

interface TableSelectionColumnHeaderProps extends Omit<React.ThHTMLAttributes<HTMLTableCellElement>, 'className' | 'onSelect'> {
  accessibleLabel?: string;
  defaultSelected?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onSelect?: React.ChangeEventHandler<HTMLInputElement>
  selectable?: boolean;
  selected?: boolean;
  sticky?: boolean;
}

export function TableSelectionColumnHeader ({
  accessibleLabel = 'Select all rows',
  defaultSelected,
  indeterminate,
  onSelect,
  selected,
  disabled,
  sticky,
  ...props
}: TableSelectionColumnHeaderProps) {
  return (
    <td
      {...props}
      className={clsx(
        'body font-normal text-gray-500 bg-white p-0 border-b border-gray-200 transition w-0 group/cell',
        {
          sticky,
          'z-10': sticky
        }
      )}
      data-sticky={sticky}
    >
      <label className='py-2 pr-3 group-last/cell:pr-[var(--cell-spacing)] group-first/cell:pl-[var(--cell-spacing)] flex items-center'>
        <Checkbox
          aria-label={accessibleLabel}
          checked={selected}
          defaultChecked={defaultSelected}
          disabled={disabled}
          indeterminate={indeterminate}
          onChange={onSelect}
        />
      </label>
      <StickyCellBorder sticky={sticky} />
    </td>
  )
}

TableSelectionColumnHeader.displayName = 'Table.SelectionColumnHeader'
